import React from "react";
import { UseFormReturn } from "react-hook-form/dist/types/form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { VenueSettingsApi } from "../../../../../../../../../../../../services/Api/Organization/types";
import TipSettingsLanguageInputs from "./TipSettingsLanguageInputs";

interface Props {
	form: UseFormReturn<VenueSettingsApi>;
}

const TipSettingsTextsCard = ({ form }: Props) => {
	const organization = useSelector(selectOrganization);
	const { t } = useTranslation();

	if (organization.languages.length === 0) return <></>;

	return (
		<fieldset className="form-group">
			<h6>{t("modules.venue_settings.field.header.title")}</h6>
			<div className="d-flex flex-column gap-3">
				{organization.languages.map((language) => (
					<TipSettingsLanguageInputs key={language} form={form} language={language} />
				))}
			</div>
		</fieldset>
	);
};

export default TipSettingsTextsCard;
